import { FilterIcon } from "lucide-react";

import { FilterSubMenuMultiselect, Row, TableOrderByDropdown } from "@/components";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

import { useTaggableUsers } from "@/contexts/TaggableUsersContext";
import { requisitionStatusOptions } from "@/lib/constants";
import { RequisitionQueryParams, RequisitionSort } from "@/types";

// * IMPORTANT: Values should match the column names in the requisition table in guac.
const sortOptions = [
  { label: "Created At", value: RequisitionSort.CreatedAt },
  { label: "Due Date", value: RequisitionSort.DateDue },
  { label: "Projected Close Date", value: RequisitionSort.DateProjectedClose },
];

export const RequisitionsQueryOptions = ({
  requisitionQueryParams,
  setRequisitionQueryParams,
}: {
  requisitionQueryParams: RequisitionQueryParams;
  setRequisitionQueryParams: (
    requisitionQueryParams: RequisitionQueryParams,
  ) => void;
}) => {
  const { userOptions } = useTaggableUsers();

  return (
    <Row className="items-center gap-2">
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button className="h-8" variant="outlineSecondary">
            <FilterIcon className="h-4 w-4" /> Filters
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="start" className="w-[150px] p-0">
          <DropdownMenuLabel>Filters</DropdownMenuLabel>
          <DropdownMenuSeparator className="mb-0" />
          <FilterSubMenuMultiselect
            label="Status"
            options={requisitionStatusOptions}
            selected={requisitionQueryParams.statuses}
            setSelected={(statuses) => {
              setRequisitionQueryParams({
                ...requisitionQueryParams,
                statuses,
              });
            }}
          />
          <FilterSubMenuMultiselect
            label="Staffers"
            options={userOptions}
            selected={requisitionQueryParams.staffers}
            setSelected={(staffers) => {
              setRequisitionQueryParams({
                ...requisitionQueryParams,
                staffers,
              });
            }}
          />
          <DropdownMenuItem
            className="p-0"
            onClick={() => {
              setRequisitionQueryParams({
                ...requisitionQueryParams,
                statuses: [],
                staffers: [],
              });
            }}
          >
            <DropdownMenuLabel className="font-medium">
              Clear all filters
            </DropdownMenuLabel>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
      <TableOrderByDropdown
        queryParams={requisitionQueryParams}
        setQueryParams={setRequisitionQueryParams}
        sortOptions={sortOptions}
      />
    </Row>
  );
};
